import { environment } from '@env/environment';
import { RankingColumnOption } from '@core/interfaces/ranking-column-option';
import { FirebaseConfig } from '@core/interfaces/firebase';
import { MockDevice } from '@core/interfaces/mock-device';
import * as LZString from 'lz-string';

export class AppHelper {

  public static storageKey: string = environment.storageKey;
  public static baseUrl: string = environment.baseUrl;
  public static apiDomain: string = environment.apiDomain;
  public static apiScheme: string = environment.apiScheme;
  public static apiPath: string = environment.apiPath;
  public static apiImgUploadsUrl: string = environment.imgBaseUrl;

  public static wpBaseUrl: string = environment.wpBaseUrl;
  public static wpApiDomain: string = environment.wpApiDomain;
  public static wpApiScheme: string = environment.wpApiScheme;
  public static wpApiPath: string = environment.wpApiPath;
  public static wpDefaultImgUrl: string = environment.wpDefaultImgUrl;


  public static committeeRoleTypeId: number = environment.committeeRoleTypeId;
  public static allowedCommitteeRoles: string[] = environment.allowedCommitteeRoles;
  public static rankingColumns: RankingColumnOption[] = environment.rankingColumns;
  public static firebaseConfig: FirebaseConfig = environment.firebase;
  public static mockDevice: MockDevice = environment.mockDevice;
  public static syncEnabled: boolean = environment.syncEnabled;

  public static withCompress: boolean = environment.withCompress;
  
  constructor() { }

  public static getStorageKey(name: string, mod: string | null = null): string {
    const modKey = mod ? mod + '_' : '';
    return AppHelper.storageKey + modKey + name;
  }

  public static isSerieU12(scoresheet): Boolean {
    return this.isSerieU10(scoresheet) || (scoresheet.game.rules && scoresheet.game.rules.player_level ? scoresheet.game.rules.player_level.level_name.includes('U12') : false);
  }

  public static isSerieU10(scoresheet): Boolean {
    return scoresheet.game.rules && scoresheet.game.rules.player_level ? scoresheet.game.rules.player_level.level_name.includes('U10') : false;
  }

  public static isSerieU8(scoresheet): Boolean {
    return scoresheet.game.rules && scoresheet.game.rules.player_level 
      ? 
      (
        scoresheet.game.rules.player_level.level_name.includes('U8') 
        || scoresheet.game.rules.player_level.level_name.includes('U7') 
        || scoresheet.game.rules.player_level.level_name.includes('U6') 
      )
      : false;
  }

  public static setItemInLocalStorage(key, item) {
    if (this.withCompress) {
      localStorage.setItem(key, LZString.compressToUTF16(JSON.stringify(item)));
    }
    else {
      localStorage.setItem(key, JSON.stringify(item));
    }
  }

  public static getItemFromLocalStorage(key) {
    const stored = localStorage.getItem(key);
    if (!stored) return null;

    // Try to decompress
    let decompressed = null;
    if (this.withCompress) {
      decompressed = LZString.decompressFromUTF16(stored);
    }

    try {
      if (decompressed) {
        // Compressed item
        return JSON.parse(decompressed);
      } else {
        // Not compressed item (old one)
        return JSON.parse(stored);
      }
    } catch (e) {
      console.error('Erreur de lecture du localStorage :', e);
      return null;
    }
  }

}
